<oui-checkbox [label]="fondsEvenementiel.libelle" [control]="control" labelStyle="body-1"></oui-checkbox>
